<template>
    <section class="home-container">
        <MasterPage title="常见问题">
            <div slot="title-icon">
                <Icon type="ios-pulse" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="100">
                    <Row>
                        <Col span="24">
                        <FormItem label="问题状态：">
                            <Select v-model="select.isDeleted" @on-change="pageNum = 1" placeholder="请选择">
                                <Option value="false">启用</Option>
                                <Option value="true" >禁用</Option>
                            </Select>
                        </FormItem>
                        <FormItem label="问题类型：">
                            <Select v-model="select.type" @on-change="pageNum = 1" placeholder="请选择">
                                <Option value="健康咨询">健康咨询</Option>
                                <Option value="帮助" >帮助</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="search">
                <Button type="primary" icon="md-add" @click="addModel=true">添加</Button>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <!--<div slot="pager">-->
                <!--<Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>-->
            <!--</div>-->
        </MasterPage>
        <Modal v-model="addModel" title="新增常见问题" @on-cancel="cancelItem">
            <Form :label-width="90">
                <FormItem label="问题类型：">
                    <Select v-model="itemAdd.type" @on-change="pageNum = 1" placeholder="请选择">
                        <Option value="健康咨询">健康咨询</Option>
                        <Option value="帮助" >帮助</Option>
                    </Select>
                </FormItem>
                <FormItem label="常见问题：">
                    <Input v-model="itemAdd.question" type="textarea" :autosize="{minRows:3, maxRows:5}" placeholder="请输入" />
                </FormItem>
                <FormItem label="问题答案：">
                    <Input v-model="itemAdd.answer" type="textarea" :autosize="{minRows:3, maxRows:5}" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="addLoading" @click="addItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="updateModel" title="修改常见问题" @on-cancel="cancelItem">
            <Form :label-width="90">
                <FormItem label="问题类型：">
                    <Select v-model="updateInfoItem.type" @on-change="pageNum = 1" placeholder="请选择">
                        <Option value="健康咨询">健康咨询</Option>
                        <Option value="帮助" >帮助</Option>
                    </Select>
                </FormItem>
                <FormItem label="常见问题：">
                    <Input v-model="updateInfoItem.question" type="textarea" :autosize="{minRows:3, maxRows:5}" placeholder="请输入" />
                </FormItem>
                <FormItem label="问题答案：">
                    <Input v-model="updateInfoItem.answer" type="textarea" :autosize="{minRows:3, maxRows:5}" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateLoading" @click="updateItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="infoModel" title="常见问题详情">
            <Form :label-width="90">
                <FormItem  label="问题类型：">
                    {{infoItem.type}}
                </FormItem>
                <FormItem  label="常见问题：">
                    {{infoItem.question}}
                </FormItem>
                <FormItem label="问题答案：">
                    {{infoItem.answer}}
                </FormItem>
            </Form>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                columns1: [
                    {
                        type: 'index',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: '类型',
                        width: 120,
                        tooltip: true,
                        key: 'type',
                        align: 'center',
                    },
                    {
                        title: '题目',
                        tooltip: true,
                        key: 'question',
                        align: 'center',
                    },
                    {
                        title: '答案',
                        tooltip: true,
                        key: 'answer',
                        align: 'center',
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:200,
                        render: (h, params) => {
                            let Buttons = [
                                // h('Button', {
                                //     props: {
                                //         type: 'primary',
                                //         icon:'ios-list-box',
                                //         label:"small",
                                //     },
                                //     style: {
                                //         marginRight: '5px'
                                //     },
                                //     on: {
                                //         click: () => {
                                //             this.infoItem_modal(this.dataList[params.index])
                                //         }
                                //     }
                                // }, '详情')
                            ]
                            if (this.dataList[params.index].isDeleted){
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-unlock',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.reuseItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '启用')
                                )
                            }else{
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-create',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.updateItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '编辑')
                                )
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon:'md-trash',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '禁用')
                                )
                            }
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                tableLoading:false,
                addModel:false,
                addLoading:false,
                updateModel:false,
                updateLoading:false,
                infoModel:false,
                select:{
                    isDeleted:'false',
                    type: ''
                },
                itemAdd:{
                    question:'',
                    answer:'',
                },
                updateInfoItem:"",
                infoItem:'',
                pageNum:1,
                pageSize:20,
                pageTotal:0,
            }
        },
        created(){
            this.pageFindItem()
        },
        methods:{
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('SQA/list',{
                    isDeleted:this.select.isDeleted,
                    type:this.select.type,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data
                        // this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'常见问题列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            addItem(){
                if (this.itemAdd.question.length <= 0){
                    return this.$Message.warning('请输入常见问题');
                }
                if (this.itemAdd.answer.length <= 0){
                    return this.$Message.warning('请输入问题答案');
                }
                if (this.itemAdd.type.length <= 0){
                    return this.$Message.warning('请选择类型');
                }
                this.addLoading = true
                this.$http.post('SQA/add',{
                    question: this.itemAdd.question,
                    type: this.itemAdd.type,
                    answer: this.itemAdd.answer,
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '常见问题新增成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'常见问题新增失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            updateItem_modal(item){
                this.updateInfoItem = JSON.parse(JSON.stringify(item));
                this.updateModel = true
            },
            updateItem(){
                if (this.updateInfoItem.question.length <= 0){
                    return this.$Message.warning('请输入常见问题');
                }
                if (this.updateInfoItem.answer.length <= 0){
                    return this.$Message.warning('请输入问题答案');
                }
                if (this.updateInfoItem.type.length <= 0){
                    return this.$Message.warning('请选择类型');
                }
                this.updateLoading = true
                this.$http.post('SQA/update',{
                    id: this.updateInfoItem.id,
                    question: this.updateInfoItem.question,
                    answer: this.updateInfoItem.answer,
                    type: this.updateInfoItem.type,
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '常见问题修改成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'常见问题修改失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.addModel = this.addLoading = this.updateModel = this.updateLoading = this.infoModel = false
                this.itemAdd.question = this.itemAdd.answer = ''
            },
            infoItem_modal(item){
                this.infoItem = item
                this.infoModel = true
            },
            reuseItem_modal(item){
                let name
                if (item.question.length > 10) {
                    name = item.question.substring(0,10)+'...'
                } else {
                    name = item.question.substring(0,11)
                }
                this.$Modal.confirm({
                    title: '确认启用常见问题“'+ name + '”',
                    loading:true,
                    onOk: () => {
                        this.reuseItem(item);
                    }
                });
            },
            reuseItem(item){
                this.$http.post('SQA/reuse',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '常见问题启用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'常见问题启用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            deleteItem_modal(item){
                let name
                if (item.question.length > 10) {
                    name = item.question.substring(0,10)+'...'
                } else {
                    name = item.question.substring(0,11)
                }
                this.$Modal.confirm({
                    title: '确认禁用常见问题“'+ name + '”',
                    loading:true,
                    onOk: () => {
                        this.deleteItem(item);
                    }
                });
            },
            deleteItem(item){
                this.$http.post('SQA/delete',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '常见问题禁用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'常见问题禁用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>


